import i18n from "../../../i18n";import { ui } from "../../../components/ui";

const fieldLabelClass = "block text-xs font-semibold text-[var(--color-text-secondary)] mb-1.5";

function HoursField({ label, field, formState, setFormState, fieldErrors, validateField, placeholder }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className={fieldLabelClass}>
        {label} <span className="text-[var(--color-error)]">*</span>
      </span>
      <input
        type="number"
        step="0.1"
        min="0"
        placeholder={placeholder}
        className={`${ui.input} w-full ${
        fieldErrors[field] ? "border-[var(--color-error)] focus:border-[var(--color-error)]" : ""}`
        }
        value={formState[field]}
        onChange={(e) => {
          const value = e.target.value;
          // Step 1: Update form state safely
          setFormState((p) => ({ ...p, [field]: value }));

          // Step 2: Extract a clean lookahead object snapshot to run active fields validation rules
          const nextState = { ...formState, [field]: value };
          validateField(field, value, nextState);
        }} />
      
      {fieldErrors[field] &&
      <p className="text-[11px] text-[var(--color-error)] mt-1">{fieldErrors[field]}</p>
      }
    </label>);

}

function BufferField({ label, field, formState, setFormState, fieldErrors, validateField, placeholder }) {
  return (
    <label className="flex flex-col gap-1.5">
      <span className={fieldLabelClass}>
        {label} <span className="text-[var(--color-error)]">*</span>
      </span>
      <input
        type="number"
        step="1"
        min="0"
        placeholder={placeholder}
        className={`${ui.input} w-full ${
        fieldErrors[field] ? "border-[var(--color-error)] focus:border-[var(--color-error)]" : ""}`
        }
        value={formState[field]}
        onChange={(e) => {
          const value = e.target.value;
          // Step 1: Update form state safely
          setFormState((p) => ({ ...p, [field]: value }));

          // Step 2: Extract a clean lookahead object snapshot to run active fields validation rules
          const nextState = { ...formState, [field]: value };
          validateField(field, value, nextState);
        }} />
      
      {fieldErrors[field] &&
      <p className="text-[11px] text-[var(--color-error)] mt-1">{fieldErrors[field]}</p>
      }
    </label>);

}

export function WorkingHourThresholdFields({ formState, setFormState, fieldErrors, validateField }) {
  const fieldProps = { formState, setFormState, fieldErrors, validateField };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <HoursField
        label="Strict Working Hours"
        field="strictWorkingHours"
        placeholder={i18n.t("examples.eG55")}
        {...fieldProps} />
      
      <HoursField
        label="Half Day Working Hours"
        field="halfDayWorkingHours"
        placeholder={i18n.t("examples.eG4")}
        {...fieldProps} />
      
      <HoursField
        label="Full Day Working Hours"
        field="fullDayWorkingHours"
        placeholder={i18n.t("examples.eG75")}
        {...fieldProps} />
      
      <div className="hidden md:block" />
      <BufferField
        label="Late Arrival Buffer (minutes)"
        field="lateArrivalBufferMinutes"
        placeholder={i18n.t("examples.eG15")}
        {...fieldProps} />
      
      <BufferField
        label="Early Exit Buffer (minutes)"
        field="earlyExitBufferMinutes"
        placeholder={i18n.t("examples.eG10")}
        {...fieldProps} />
      
    </div>);

}
